export default function initM1() {
    const links = jQuery('.lottieLinks')
    const bannerEle = jQuery("#bannerAnimations")
    if(links.length > 0){
        let currentLinkIndex = 0
        const speed = bannerEle.data('speed') * 1000
        setInterval(() => {
            if(links.children().length > (currentLinkIndex + 1)){
                currentLinkIndex++
            } else {
                currentLinkIndex = 0
            }
        }, speed);
        bannerEle.on('click',function(){
            const linkTarget = jQuery(links.children()[currentLinkIndex]).text()
            window.location.href = linkTarget
        })
    }
}